import helpConfig from './help'

const env = process.env.VUE_APP_ENVIRONMENT || 'local'
// Config plugins provides $config and $apiConfig on global Vue object
export default {
  install (Vue) {
    Vue.$apiConfig = require('./api.json')
    Vue.$config = require('./' + env + '.json')
    Vue.$helpConfig = helpConfig
  }
}
